// extracted by mini-css-extract-plugin
export var alertIcon = "_uo-0";